import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import Seo from "@/components/Seo";

export default function NotFound() {
  return (
    <>
      <Seo title="Page not found" path="/404" />
      <section className="flex min-h-[60vh] items-center justify-center px-4 py-20">
        <div className="text-center">
          <p className="font-display text-7xl font-bold text-[#133827]">404</p>
          <h1 className="mt-4 font-display text-2xl font-semibold text-[#18201B]">Page not found</h1>
          <p className="mt-2 text-[#526057]">The page you're looking for doesn't exist or has moved.</p>
          <Link to="/">
            <Button data-testid="notfound-home-btn" className="mt-6 bg-[#133827] text-white hover:bg-[#0d261a]">Back to Home</Button>
          </Link>
        </div>
      </section>
    </>
  );
}
